import React, { useState, useRef } from 'react';
import AboutDialog from '../../AboutDialog/AboutDialog';
import Button from '@material-ui/core/Button';
import DeviceSelectionDialog from '../../DeviceSelectionDialog/DeviceSelectionDialog';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuContainer from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreIcon from '@material-ui/icons/MoreVert';
import Typography from '@material-ui/core/Typography';
import { Theme, useMediaQuery } from '@material-ui/core';
import useParentConnectionContext from '../../../hooks/useParentConnectionContext/useParentConnectionContext';

export default function Menu(props: { buttonClassName?: string }) {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [aboutOpen, setAboutOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const { parent } = useParentConnectionContext();

  const anchorRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        onClick={() => {
          setMenuOpen(isOpen => !isOpen);
          if (parent?.trackEvent) {
            parent.trackEvent('video_call_menu_toggle_clicked');
          }
        }}
        ref={anchorRef}
        className={props.buttonClassName}
      >
        {isMobile ? (
          <MoreIcon />
        ) : (
          <>
            Settings
            <ExpandMoreIcon />
          </>
        )}
      </Button>
      <MenuContainer
        open={menuOpen}
        onClose={() => {
          setMenuOpen(isOpen => !isOpen);
          if (parent?.trackEvent) {
            parent.trackEvent('video_call_menu_toggle_clicked');
          }
        }}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: isMobile ? -55 : 'bottom',
          horizontal: 'center',
        }}
      >
        <MenuItem
          onClick={() => {
            setAboutOpen(true);
            if (parent?.trackEvent) {
              parent.trackEvent('video_call_info_button_clicked');
            }
          }}
        >
          <Typography variant="body1">About</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSettingsOpen(true);
            if (parent?.trackEvent) {
              parent.trackEvent('video_call_audio_video_settings_clicked');
            }
          }}
        >
          <Typography variant="body1">Audio and Video Settings</Typography>
        </MenuItem>
      </MenuContainer>
      <AboutDialog
        open={aboutOpen}
        onClose={() => {
          setAboutOpen(false);
          setMenuOpen(false);
        }}
      />
      <DeviceSelectionDialog
        open={settingsOpen}
        onClose={() => {
          setSettingsOpen(false);
          setMenuOpen(false);
        }}
      />
    </>
  );
}
